import { Component } from "react";
import "../css/bootstrap.css";
import $ from "jquery";
import Add from "../images/add.png";
import Edit from "../images/edit.png";
import Delete from "../images/delete.png";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { saveItCareerForm } from "../service";

class Enquiry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditorEnquiryActive: "0",
            enquiryArray: [],
            enquiryContentId: "",
            enquiryContentDataSubId: "",
            enquiryArrayList: [],
            contentDataSubDescription: "",
            contentDataSubTitle: "",
            altText: "",
            contentDataSubSubtitle: ""
        }

    }

    componentDidMount() {
        this.setState({
            enquiryContentId: this.props.enquiryArray[0].contentDataId,
            enquiryArrayList: this.props.enquiryArray[0].listing,

        });

        if (this.props.enquiryArray[0].listing.length > 0) {
            this.setState({
                contentDataSubDescription: this.props.enquiryArray[0].listing[0].contentDataSubDescription,
                contentDataSubTitle: this.props.enquiryArray[0].listing[0].contentDataSubTitle,
                altText: this.props.enquiryArray[0].listing[0].altText,
                contentDataSubSubtitle: this.props.enquiryArray[0].listing[0].contentDataSubSubtitle
            });
        }
    }
    save() {
        var flag = true
        if ($("#txtTitles").val() === '') {
            alert("Enter Text")
            $("#txtTitles").focus()
            return false;
        }
        if ($("#txtButtonTitles").val() === '') {
            alert("Enter Text")
            $("#txtButtonTitles").focus()
            return false;
        }
        if ($("#txtSubTitle").val() === '') {
            alert("Enter Text")
            $("#txtSubTitle").focus()
            return false;
        }
        if (flag == true) {
        const postData = {
            functionName: "saveContentDataSub",
            contentDataId: this.state.enquiryContentId,
            contentDataSubId: this.props.enquiryArray[0].listing.length > 0 ? this.props.enquiryArray[0].listing[0].contentDataSubId : "",
            contentDataSubDescription: this.state.contentDataSubDescription,
            contentDataSubTitle: this.state.contentDataSubTitle,
            siteId: "",
            contentDataSubIsApproved: "0",
            image: "",
            userRole: "SuperAdmin",
            oldImage: "",
            isSaveDraft: "0",
            contentDataSubSortOrder: "",
            pageId: "1",
            altText: this.state.altText,
            h3Tag: "",
            contentDataSubSubtitle: this.state.contentDataSubSubtitle,
        };
        console.log("postDataaaa", postData);
        saveItCareerForm(postData).then((data) => {
            console.log("hhhhhh.....", data);
            if (data.data.success == 1) {
                // alert("addedsuccessfully")
                this.props.getData();
                this.cancelenquiry1();
            }
        });
    }
    }

    onFormClick = () => {
        window.location.href = (this.state.contentDataSubSubtitle === "" ? 'javascript:void(0);window.scrollTo(0, 0);' : this.state.contentDataSubSubtitle)
    }
    editenquiry() {
        $(".overlapSection").addClass("editActive");
        this.setState({ isEditorEnquiryActive: "1" });

    }
    deleteEnquirysec(mode) {
        if (mode === "delete") {
            const postData = {
                functionName: "delete",
                contentDataSubId: this.props.enquiryArray[0].listing[0].contentDataSubId,
            };
            if (window.confirm("Do you want to delete?")) {
                saveItCareerForm(postData).then((data) => {
                    if (data.data.success == 1) {
                        this.props.getData();
                        window.location.reload();
                    }
                });
            } else {
                return false;
            }
        }
    }
    Addenquiry() {
        $(".overlapSection").addClass("editActive");
        this.setState({ isEditorEnquiryActive: "1" });
    }
    cancelenquiry1() {
        $(".overlapSection").removeClass("editActive");
        this.setState({ isEditorEnquiryActive: "0" });
    }
    cancelenquiry() {
        $(".overlapSection").removeClass("editActive");
        this.setState({ isEditorEnquiryActive: "0" });
        this.setState({
            contentDataSubDescription: this.props.enquiryArray[0].listing[0].contentDataSubDescription,
            contentDataSubTitle: this.props.enquiryArray[0].listing[0].contentDataSubTitle,
            altText: this.props.enquiryArray[0].listing[0].altText,
            contentDataSubSubtitle: this.props.enquiryArray[0].listing[0].contentDataSubSubtitle
        });
    }

    render() {
        return (
            <section className="overlapSection">
                {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
                    <>
                        <div className="adminIconMain">
                            {this.props.enquiryArray[0].listing.length == "0" ?
                                <span
                                    className="editIcon addButton"
                                    onClick={(e) => {
                                        this.Addenquiry();
                                    }}
                                >
                                    <img src={Add} />
                                </span> :
                                <>
                                    <span
                                        class="editIcon editButton"
                                        onClick={(e) => {
                                            this.editenquiry();
                                        }}
                                    >
                                        <img src={Edit} />
                                    </span>
                                    {/* <span class="editIcon lockButton"><img src={lock} /></span> */}
                                    <span class="editIcon DeleteIcon"
                                        onClick={() => this.deleteEnquirysec("delete")}
                                    >
                                        <img src={Delete} />
                                    </span>
                                </>}
                        </div>
                    </>
                }
                <div className="container">
                    <div className="col-md-12 overlapSectionInner text-center wow slideInRight enquiryeditorWrapr">
                        <span className="overlap_sectntext">{this.state.contentDataSubDescription}</span>{" "}
                        {this.state.altText ? <a className="calltoActionBtn gotoForm calltoActionBtnEnqury" href="#" onClick={() => this.onFormClick()}>
                            <i className="ion-compose"></i>{this.state.altText}
                        </a> : ""}
                        <span className="overlap_sectntext overlap_sectntextlast">{this.state.contentDataSubTitle}</span>
                        {this.state.isEditorEnquiryActive === "1" ?
                            <div className="row w-100">
                                <div className="col-lg-3">

                                    <label>Title</label>
                                    <input
                                        type="text"
                                        value={this.state.contentDataSubDescription}
                                        placeholder="Enter Title"
                                        autocomplete="off"
                                        maxlength="80"
                                        class="editInput"
                                        id="txtTitles"
                                        onChange={(e) => {
                                            this.setState({
                                                contentDataSubDescription: e.target.value
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col-lg-3">
                                    <label>Button Title</label>
                                    <input
                                        value={this.state.altText}
                                        type="text"
                                        placeholder="Enter Button Title"
                                        autocomplete="off"
                                        maxlength="80"
                                        class="editInput"
                                        id="txtButtonTitles"
                                        onChange={(e) => {
                                            this.setState({
                                                altText: e.target.value
                                            });
                                            
                                        }}
                                    />
                                </div>
                                <div className="col-lg-3">
                                    <label>Button URL</label>
                                    <input
                                        value={this.state.contentDataSubSubtitle}
                                        type="text"
                                        placeholder="Enter Button URL"
                                        autocomplete="off"
                                        maxlength="80"
                                        class="editInput"
                                        id="txtButtonUrl"
                                        onChange={(e) => {
                                            this.setState({
                                                contentDataSubSubtitle: e.target.value
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col-lg-3">
                                    <label>Sub Title</label>
                                    <input
                                        value={this.state.contentDataSubTitle}
                                        type="text"
                                        placeholder="Enter Sub Title"
                                        autocomplete="off"
                                        maxlength="80"
                                        class="editInput"
                                        id="txtSubTitle"
                                        onChange={(e) => {
                                            this.setState({
                                                contentDataSubTitle: e.target.value
                                            });
                                        }}
                                    />
                                </div>

                            </div>
                            : ""}

                        <div className="editPanelButton">
                            {/* <span className="saveButton saveDraft">Save Draft</span> */}
                            <span className="saveButton" onClick={() => { this.save() }}>Submit</span>
                            <span className="cancelButton" onClick={(e) => { this.cancelenquiry() }}>Cancel</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Enquiry;
